import React, { Component } from "react";
import DateTimePicker from "../../../react-datetime-picker/entry";
import moment from "moment";
import { isMobile } from "react-device-detect";

class DateDropdown extends Component {
  getDateValue = () => {
    // let momDate = moment()
    //   .utc()
    //   .format();
    // console.log("=====================" + momDate);
    // if (this.props.value !== "") {
    //   momDate = moment(this.props.value)
    //     .utc()
    //     .format();
    // }

    // return momDate;
    let newDataObj = new Date();
    if (
      this.props.value &&
      this.props.value !== undefined &&
      this.props.value !== ""
    ) {
      let strDate = moment(this.props.value, this.props.formatOut);
      //console.log("updating date value: " + strDate);
      newDataObj = new Date(strDate);
    }
    //console.log("~!~!~!~!~!~!: newDateObj: " + newDataObj);
    return newDataObj;
  };

  setDateValue = newDateValue => {
    //console.log("Something happening here...");
    if (newDateValue !== "") {
      let momDateValue = moment(newDateValue).format(this.props.formatOut);
      //console.log(momDateValue);
      this.props.onChange(momDateValue, this.props.fieldName, true);
    }
  };
  render() {
    return (
      <div
        className="row"
        style={{
          marginLeft: "1px",
          marginRight: "1px",
          alignItems: "center",
          padding: "2px",
          border: "0px",
          borderBottom: "0px",
          borderBottomColor: "#cccccc",
          borderStyle: "solid"
        }}
      >
        <div
          className="col-sm-4 align-self-center”"
          style={{
            margin: "0px",
            verticalAlign: "middle",
            height: "auto",
            padding: "0px"
          }}
        >
          <div
            style={{
              marginTop: isMobile ? "13px" : "0px",
              verticalAlign: "middle",
              lineHeight: isMobile ? "20px" : "37px",
              padding: "0px",
              color: isMobile ? "grey" : "black",
              marginBottom: isMobile ? "-1px" : "0px"
            }}
          >
            {this.props.title}
          </div>
        </div>
        <div
          className="col-sm-8"
          style={{
            display: "block",
            padding: "6px",
            textAlign: "left",
            border: "1px solid gainsboro",
            borderRadius: "5px",
            backgroundColor: "white"
          }}
        >
          <DateTimePicker
            maxDetail={this.props.maxDetail}
            format={this.props.format}
            onChange={value => this.setDateValue(value)}
            value={this.getDateValue()}
            calendarClassName={"container"}
            clearIcon={null}
            disableClock={true}
            disabled={this.props.disabled}
          />
        </div>
      </div>
    );
  }
}

export default DateDropdown;



// WEBPACK FOOTER //
// ./src/app/components/Screens/FieldsComponents/DateDropdown/DateDropdown.jsx